import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URI,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para manejar errores globalmente
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Error en la petición:', error);
    return Promise.reject(error);
  }
);

interface ApiResponse {
  data: string;
  success: boolean;
  details: string;
}

export const sendMessage = async (message: string): Promise<ApiResponse> => {
  try {
    const response = await api.post('v1/chatbot/ask', { question: message });
    console.log('axios API:', response);
    
    if (!response.data || !response.data.data) throw new Error('Invalid response format');

    console.log(response.status);
    
    let data = {
      data: response.data.data,
      success: response.status === 200 ? true : false,
      details: response.data.details || 'No hay detalles adicionales disponibles'
    }
    return data;
  } catch (error) {
    return Promise.reject({
      data: 'Error al enviar el mensaje:',
      success: false,
      details: error || 'No hay detalles adicionales disponibles'
    });
  }
};

export default api;